<ul class="primary-menu">
  @for (menuItem of menuItems; track menuItem) { @if (menuItem | displayWithAuth : authInfo()) {
  <li>
    @if (!menuItem?.link?.is_external) {
    <a class="menu-item" [appNavigateToUrl]="menuItem?.link?.url || menuItem?.url">
      {{ menuItem?.link?.label || menuItem?.label }}
    </a>
    } @if (menuItem?.link?.is_external) {
    <a class="menu-item" [href]="menuItem?.link?.url || menuItem?.url">
      {{ menuItem?.link?.label || menuItem?.label }}
    </a>
    }
    <ul>
      @for (subItem of menuItem?.items; track subItem) {
      <li [class.large]="subItem.type === MenuItemType.Large">
        <a class="menu-sub-item" [appNavigateToUrl]="subItem?.url">{{ subItem?.label }}</a>
      </li>
      }
    </ul>
  </li>
  } }
</ul>
